import Tabs from "../tabs";
import { useSelector } from "react-redux";
import CircularLoader from "../../../../components/loaders/circularLoader";
import { Box, Dialog, DialogContent } from "@mui/material";
import { useState, useEffect } from "react";
import SnackbarMessage from "../../../../components/snackBar/snackBar";
import MergeTypeOutlinedIcon from "@mui/icons-material/MergeTypeOutlined";
import AddLinkOutlinedIcon from "@mui/icons-material/AddLinkOutlined";
import NameCardList from "../nameCardList";
import { BranchDepartmentCreateForm } from "./branchDepartmentCreation";
import { qrDialogPaperSx, QrModalHeader } from "../../../qrCode/components/qrUi";

export default function BranchDepartmentList() {
    const { branchDepartments, status, error } = useSelector((state) => state.general);

    const [search, setSearch] = useState("");
    const [createOpen, setCreateOpen] = useState(false);

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });

    useEffect(() => {
        if (status === "failed") {
            setSnackbar({
                open: true,
                message: error,
                severity: "error",
            });
        }
    }, [status, error]);

    // Same filter as before
    const filteredBranchDepartments = status !== "succeeded" ? [] : branchDepartments.filter((item) => item.branch_department_name.toLowerCase().includes(search.toLowerCase()));

    return (
        <div>
            <Tabs onCreate={() => setCreateOpen(true)}>
                <Box>
                    {/* Loader */}
                    {status === "loading" && (
                        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
                            <CircularLoader color="success" />
                        </Box>
                    )}

                    {/* Success */}
                    {status === "succeeded" && (
                        <NameCardList
                            items={filteredBranchDepartments}
                            getName={(item) => item.branch_department_name}
                            getId={(item) => item.id}
                            search={search}
                            onSearchChange={(value) => {
                                // no leading space (same rule as before)
                                if (!value.startsWith(" ")) {
                                    setSearch(value)
                                }
                            }}
                            searchPlaceholder="Search Branch Department"
                            countIcon={<MergeTypeOutlinedIcon />}
                            countLabel="branch department"
                            watermark={<MergeTypeOutlinedIcon />}
                            fullText
                        />
                    )}
                </Box>
            </Tabs>

            {/* Create branch department popup */}
            <Dialog
                open={createOpen}
                onClose={() => setCreateOpen(false)}
                fullWidth
                maxWidth="sm"
                PaperProps={{ sx: { ...qrDialogPaperSx, maxWidth: { sm: 620 } } }}
            >
                <QrModalHeader
                    icon={<AddLinkOutlinedIcon />}
                    title="Create Branch Department"
                    subtitle="Link a department to one or more branches"
                    onClose={() => setCreateOpen(false)}
                />
                <DialogContent sx={{ p: 0 }}>
                    {/* remounts on each open, so the form starts empty */}
                    {createOpen && (
                        <BranchDepartmentCreateForm
                            embedded
                            onCancel={() => setCreateOpen(false)}
                            onSuccess={(message) => {
                                setCreateOpen(false);
                                setSnackbar({ open: true, message: message || "Branch department created", severity: "success" });
                            }}
                        />
                    )}
                </DialogContent>
            </Dialog>

            <SnackbarMessage open={snackbar.open} message={snackbar.message} severity={snackbar.severity} onClose={() => setSnackbar(prev => ({ ...prev, open: false }))} />
        </div>
    );
}
